export default __webpack_public_path__ + "static/media/electricity-no.25610d6c.png";